import { forwardRef } from 'react';
import CustomLink from 'components/shared/CustomLink';
import type { CustomLinkProps } from 'components/shared/CustomLink';
import styles from './performanceLabContactLinks.module.css';

export const PERFORMANCE_LAB_PHONE_E164 = '+918047282422';
export const PERFORMANCE_LAB_PHONE_HREF = `tel:${PERFORMANCE_LAB_PHONE_E164}`;

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

export const DirectionsLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function DirectionsLink({ className, ...rest }, ref) {
    return (
      <CustomLink
        ref={ref}
        className={cx(styles.directionsLink, className)}
        {...rest}
      />
    );
  },
);

export const PhoneLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function PhoneLink({ className, ...rest }, ref) {
    return (
      <DirectionsLink
        ref={ref}
        className={cx(styles.phoneLink, className)}
        {...rest}
      />
    );
  },
);
